import callCmAPI from 'services/helpers/call-cm-api'
import {
  EscalationListParams,
  EscalationListResponse,
  WebApi2Response,
} from 'types'

/******************
 * Fetch from API *
 ******************/

/**
 * Every escalation across every customer, paginated server-side.
 *
 * Every filter is optional: called with none, this returns the whole queue,
 * which is what the Escalations page shows on load.
 */
export const listEscalations = (
  params: EscalationListParams = {},
): Promise<WebApi2Response<EscalationListResponse>> => {
  const search = new URLSearchParams()
  if (params.page !== undefined) search.set('page', String(params.page))
  if (params.pageSize !== undefined) {
    search.set('page_size', String(params.pageSize))
  }
  if (params.countries?.length) {
    search.set('countries', params.countries.join(','))
  }
  if (params.status?.length) search.set('status', params.status.join(','))
  if (params.localId) search.set('local_id', params.localId)
  if (params.q) search.set('q', params.q)
  const queryString = search.toString()

  return callCmAPI(`/escalation${queryString ? `?${queryString}` : ''}`, {
    method: 'get',
  })
    .then((res) => {
      return {
        success: true as const,
        data: res.data as EscalationListResponse,
      }
    })
    .catch((err) => {
      return {
        success: false as const,
        data: null,
        error: err,
      }
    })
}
